import React, { StrictMode } from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { BugsnagErrorBoundary } from '@bugsnag/plugin-react'
import '@stripe/stripe-js' // Injects the Stripe script as soon as the StripeProvider is rendered
import { createRoot } from 'react-dom/client'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from 'react-query'

import { queryClient } from 'config/queryClient'
import AppRoot from 'components/AppRoot'
import { AuthProvider } from 'components/AuthProvider'
import reportWebVitals from 'utils/reportWebVitals'
import theme from 'utils/theme'

import './index.css'

Bugsnag.start({
  appVersion: process.env.REACT_APP_VERSION,
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY as string,
  enabledReleaseStages: ['dev', 'production', 'local'],
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.REACT_APP_BUGSNAG_RELEASE_STAGE
})

const ErrorBoundary: BugsnagErrorBoundary | undefined =
  Bugsnag.getPlugin('react')?.createErrorBoundary(React)

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element not found')
}

const root = createRoot(container)
root.render(
  <StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    >
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <BrowserRouter future={{ v7_startTransition: true }}>
              <AuthProvider>
                <AppRoot ErrorBoundary={ErrorBoundary} />
              </AuthProvider>
            </BrowserRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
// serviceWorker.register()
